import { useState } from 'react';
import { useSetRachelMessageFeedback } from '../../../../../../../../services/modules/rachelChats/rachelChats.mutations';
import { useRachelChatFeedbackMap } from '../../../../../../../../services/modules/rachelChats/rachelChats.queries';
import { RachelMessageFeedbackRating } from '../../../../../../../../services/modules/rachelChats/rachelChats.types';
import { useRachelActiveChatId } from '../../../../../../hooks/useRachelActiveChatId';
import { RachelFeedbackSubmitParams } from './components/RachelMessageFeedbackModal/useRachelMessageFeedbackModal';

interface UseRachelMessageFeedbackParams {
  messageId: string;
}

export const useRachelMessageFeedback = ({ messageId }: UseRachelMessageFeedbackParams) => {
  const chatId = useRachelActiveChatId();
  const { feedbackByMessageId } = useRachelChatFeedbackMap(chatId);
  const setFeedback = useSetRachelMessageFeedback();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingRating, setPendingRating] = useState<RachelMessageFeedbackRating>('like');

  const feedback = feedbackByMessageId[messageId];
  const rating = feedback?.rating ?? null;
  const comment = feedback?.comment ?? null;
  const problemType = feedback?.problemType ?? null;

  const closeModal = () => setIsModalOpen(false);

  const openModalWithRating = (nextRating: RachelMessageFeedbackRating) => {
    if (!chatId) {
      return;
    }
    setPendingRating(nextRating);
    setIsModalOpen(true);
  };

  const onLike = () => openModalWithRating('like');

  const onDislike = () => openModalWithRating('dislike');

  const submit = ({
    comment: feedbackComment,
    problemType: feedbackProblemType,
  }: RachelFeedbackSubmitParams) => {
    if (!chatId) {
      return;
    }
    setFeedback.mutate({
      chatId,
      messageId,
      rating: pendingRating,
      comment: feedbackComment,
      problemType: feedbackProblemType,
    });
  };

  return {
    rating,
    comment,
    problemType,
    pendingRating,
    isFeedbackEnabled: !!chatId,
    onLike,
    onDislike,
    isModalOpen,
    closeModal,
    submit,
  };
};
